import { useTranslation } from 'react-i18next';
import { IProductType } from '../../../../../interfaces';
import { AnimatePresence, motion } from 'framer-motion';
import { Box } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import ProductTypeListItem from '../../../../productTypeListItem/ProductTypeListItem';
import { cardBasicVariants } from '../../../../../config/animation';

interface Props {
    productTypes: IProductType[];
    productId: number;
}

export default function ProductTypesList({ productTypes, productId }: Props) {
    const [t] = useTranslation();

    return (
        <Box display="flex" flexDirection="column" gap="3" fontWeight="500">
            <AnimatePresence>
                {productTypes.map((productType, index) => {
                    return (
                        <motion.div
                            key={index}
                            variants={cardBasicVariants}
                            custom={index}
                            initial="hidden"
                            animate="visible">
                            <Link
                                to={'/product/' + productId + '?type=' + productType.type}
                                state={{ pageName: t(`steam-${productType.type}`) }}>
                                <ProductTypeListItem productType={productType} />
                            </Link>
                        </motion.div>
                    );
                })}
            </AnimatePresence>
        </Box>
    );
}
